<template>
  <settings-template :title="title" :layout="layout" :show-device-picker="showDevicePicker">
    <range-input-with-unit v-model="value" :alternative-units="alternativeUnits" :min="min" :max="max" />
  </settings-template>
</template>

<script>
import appearanceChangerMixin from "@/mixins/campaign-builder/appearance-changer-mixin"
import SettingsTemplate from "@/components/campaign-builder/settings-elements/SettingsTemplate"
import RangeInputWithUnit from "@/components/common/RangeInputWithUnit"

export default {
  name: "SettingsWidth",
  components: { RangeInputWithUnit, SettingsTemplate },
  props: {
    variable: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: "Width"
    },
    size: {
      type: String,
      default: "normal"
    },
    alternativeUnits: {
      type: Array,
      default: () => ["px", "vw", "%"]
    }
  },
  mixins: [appearanceChangerMixin],
  computed: {
    value: {
      get() {
        return this.getStyleVariableValue(this.env, this.variable, 1)
      },
      set(width) {
        this.setStyleVariableDirect({
          env: this.env,
          variable: this.variable,
          value: width.value + width.unit
        })
      }
    },
    min() {
      return 0
    },
    max() {
      if (this.value.unit === "px") {
        return 600
      }

      return 100
    }
  }
}
</script>
